import { graphql } from '@api/generated';

export const UPDATE_USER_MUTATION = graphql(`
  mutation UpdateUser(
    $userId: ID!
    $seatLevel: UserSeatLevel
    $recordingPreference: RecordingPreference
    $phoneNumber: String
    $e911Address: AddressInput
  ) {
    updateUser(
      userId: $userId
      input: {
        seatLevel: $seatLevel
        recordingPreference: $recordingPreference
        phoneNumber: $phoneNumber
        e911Address: $e911Address
      }
    ) {
      id
      seatLevel
      ...UserDetailPersonalLine
    }
  }
`);

export const ADD_USER_QUEUE_MUTATION = graphql(`
  mutation AddUserQueue($userId: ID!, $queueId: ID!) {
    addUserQueue(userId: $userId, queueId: $queueId) {
      id
      ...UserDetailQueues
    }
  }
`);

export const REMOVE_USER_QUEUE_MUTATION = graphql(`
  mutation RemoveUserQueue($userId: ID!, $queueId: ID!) {
    removeUserQueue(userId: $userId, queueId: $queueId) {
      id
      ...UserDetailQueues
    }
  }
`);

export const UPDATE_USER_QUEUE_MUTATION = graphql(`
  mutation UpdateUserQueue(
    $userId: ID!
    $queueId: ID!
    $input: UserQueueUpdateInput!
  ) {
    updateUserQueue(userId: $userId, queueId: $queueId, input: $input) {
      id
      ...UserDetailQueues
    }
  }
`);
